// ^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$
// ^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$
// export const EMAIL = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/i
export const EMAIL = /^.*@.*$/
export const ZIPCODE = /^[0-9]{1,6}$/
export const PASSWORD = /^[0-9a-zA-Z]{6,20}$/
export const WEBSITE = /^https?\:\/\//
export const PHONENUMBER = /^[0-9()-]{1,}$/
export const COUPON = /^[0-9]*$/



// WEBPACK FOOTER //
// ./src/utils/regExp.js